import CircleShape from './classes/circleclass.js';
import { MeasureContainer } from './classes/measure_container.js';


var doek = document.getElementById('doek');


const iconImages = document.querySelectorAll('.icon_image');



iconImages.forEach((image) => {
  gsap.to(image, {
    scale: 0.90,
    duration: 1,
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut"
  });
});